import $ from 'jquery-slim';

export const clearSearch = (props, focus = true) => {
    const { change, abortItems } = props;
    change("keyword", "");
    abortItems();
    if (focus === true) {
        $(`input[name="keyword"]`).focus();
    }
}